export default class Upload {
    static get SIZE() {
        return 15000000;
    }

    static set MsgLimite(limit) {
        return `Máximo de ${limit} arquivos.`;
    }
}
